import React, { useRef, useState, useEffect } from "react";
import CategoryMenu from "../category-menu";
import HorizontalCategoryMenu from "../category-menu/horizontal-category-menu";
import { ReactComponent as ChevronDown } from "svgs/chevron-down.svg";
import clsx from "clsx/lite";

export const DropdownContent = ({ isOpen, position, data }) => {
	const contentRef = useRef(null);
	const [height, setHeight] = useState(0);

	// This is used for animating the dropdown height
	useEffect(() => {
		if (!contentRef.current) return;
		const el = contentRef.current;
		setHeight(isOpen ? el.scrollHeight : 0);
	}, [isOpen, data]);

	useEffect(() => {
		if (!isOpen || !contentRef.current) return;

		const observer = new ResizeObserver(() => {
			setHeight(contentRef.current.scrollHeight);
		});

		observer.observe(contentRef.current);
		return () => observer.disconnect();
	}, [isOpen]);

	return (
		<div
			className={clsx("header-dropdown-menu", position)}
			style={{ height: isOpen ? `${height}px` : "0px", }}
		>
			{isOpen && (
				<div ref={contentRef}>
					{data.isHorizontal
						? <HorizontalCategoryMenu data={data} />
						: <CategoryMenu data={data} />}
				</div>
			)}
		</div>
	);
};

export const DropdownTrigger = ({ link, isOpen, handleOpenMenu }) => (
	<button className="my-auto flex"
		tabIndex={0}
		onMouseEnter={() => handleOpenMenu(link)}
		onClick={() => handleOpenMenu(link, { forceCloseSearch: true })}
		onKeyDown={(e) => {
			if (e.key === "Enter") {
				handleOpenMenu(link, { forceCloseSearch: true });
			}
		}}
	>
		<span className="desktop-header-menu-item">
			{link.title}
		</span>
		<ChevronDown className={clsx("transition-transform duration-300 my-auto transform-gpu", isOpen && "rotate-180")} />
	</button>
);